import {
  NavigationGuardNext,
  RouteRecordRaw,
} from 'vue-router';

import { WalletUserDetailResponse } from '@/repositories/generated';
import {
  useEditWalletUserStore,
  useRootStore,
  useWalletServiceSettingStore,
} from '@/store';

/**
 * 編集権限がない場合は404へリダイレクト
 * @param next NavigationGuardNext
 * @param initData 初期データ
 */
const redirectToNotFoundIfNotEditable = (next: NavigationGuardNext, initData?: WalletUserDetailResponse) => {
  const hasPhysicalPrepaidCard = (initData?.walletUserDetailPaymentMethodInfo?.walletUserPrepaidInfos ?? [])
    .some((prepaidInfo) => prepaidInfo.physicalPrepaidCardNumber);

  if (hasPhysicalPrepaidCard) {
    next({ name: 'NotFound' });
  }
};

// ウォレットユーザー関連
export const walletUserRoutes: Array<RouteRecordRaw> = [
  {
    name: 'WalletUser',
    component: () => import('@/components/pages/wallet-user/index.vue'),
    path: '/wallet-user',
    meta: {
      title: 'ウォレットユーザ',
      requiredAuthority: 'APP_USERS',
    },
  },
  {
    name: 'WalletUserId',
    component: () => import('@/components/pages/wallet-user/detail/index.vue'),
    path: '/wallet-user/:id',
    meta: {
      title: 'ウォレットユーザ詳細',
      requiredAuthority: 'APP_USERS',
    },
  },
  {
    name: 'WalletUserEdit',
    component: () => import('@/components/pages/wallet-user/detail/edit/index.vue'),
    path: '/wallet-user/:id/edit',
    meta: {
      title: 'ウォレットユーザ編集',
      requiredAuthority: 'EDIT_APP_USERS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const editWalletUserStore = useEditWalletUserStore();

      // 確認画面以外から遷移した場合はstoreに詳細APIを叩いた結果をセットし、formをリセットする
      if (from.name !== 'WalletUserEditConfirm') {
        await editWalletUserStore.setInitData(id);
        editWalletUserStore.$resetForm();
        useRootStore().$reset();
      }
      redirectToNotFoundIfNotEditable(next, editWalletUserStore.initData);

      // ウォレットサービス設定を取得
      const walletServiceId = editWalletUserStore.initData?.walletServiceId ?? '';
      await useWalletServiceSettingStore()
        .getWalletServiceSetting([
          walletServiceId,
        ]);

      next();
    },
  },
  {
    name: 'WalletUserEditConfirm',
    component: () => import('@/components/pages/wallet-user/detail/edit/confirm/index.vue'),
    path: '/wallet-user/:id/edit/confirm',
    meta: {
      title: 'ウォレットユーザ編集確認',
      requiredAuthority: 'EDIT_APP_USERS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const store = useEditWalletUserStore();
      const {
        form,
        initData,
      } = store;

      redirectToNotFoundIfNotEditable(next, initData);

      if (from.path === `/wallet-user/${id}/edit` && !(form == null || initData == null)) {
        next();
      } else {
        next({ path: `/wallet-user/${id}`, replace: true });
      }
    },

  },
];
